@switch (currentPage) {
  @case (1) {
    <app-change-action-general-sidebar
      (next)="incrementPage()"
      (back)="decrementPage()"
      (submitPcoUpdate)="updatePco()"
      [(model)]="model.generalData"
    ></app-change-action-general-sidebar>
  }
  @case (2) {
    @if (model.generalData.type === 'Potential Change Order') {
      <app-change-action-pco-sidebar
        (saveForm)="createPco()"
        (back)="decrementPage()"
        [(lineItemGroups)]="model.lineItems"
      ></app-change-action-pco-sidebar>
    } @else {
      <app-change-action-cor-sidebar
        [name]="model.generalData.number"
        (saveForm)="saveCOR()"
        (back)="decrementPage()"
        [isEdit]="data?.isEdit"
        [CORId]="model.generalData?.id ?? null"
        [(selectedPCOIds)]="model.selectedPCOIds"
      >
      </app-change-action-cor-sidebar>
    }
  }
}
